{{#each items}}
  <div class="item {{itemname}} {{class}}" id="{{id}}">
    {{#if header}}
      <div {{#if animation}}data-anijs="{{animation}}"{{/if}} class="header {{#if header_class}}{{header_class}}{{/if}}">
        {{t header}}
      </div>
    {{/if}}
    {{#if displayDescription}}
      <div {{#if animation}}data-anijs="{{animation}}"{{/if}} class="description {{#if custom}}marked-down{{/if}} {{#if description_class}}{{description_class}}{{/if}}">
        {{! Note: description is not HTML encoded and is an XSS risk. }}
        {{! Some courses need to and rely upon injecting HTML here for display purposes. }}
        {{#if forge_mode}}
          {{t description}}
        {{else}}
          {{{displayDescription}}}
        {{/if}}
      </div>
    {{/if}}
    {{#if blocks}}
      <div data-region="{{../cid}}-items-{{@index}}-blocks"></div>
    {{/if}}
  </div>
{{/each}}
